import { FormatedField, FieldView } from "../types/fields.types";
import { isCustomizedField } from "../utils/isCustomizedField";

export const setFieldValueAcordingToView = (field: FormatedField, value: any, fieldView: FieldView) => {
    if (!value) return null;

    if (isCustomizedField(field)) return value;

    switch (fieldView) {
        case "grid":
            return value.value;
        case "group":
            return adaptValueBasedOnFieldType(field, value);
    }
};

const adaptValueBasedOnFieldType = (field: FormatedField, value: any) => {
    const fieldValue = value[field.field];
    if (fieldValue === undefined || fieldValue === null) return null;

    if (field?.settings?.interface === "file-image") {
        return [{ directus_files_id: fieldValue.id }];
    }
    return fieldValue;
};
